import FadeIn from "./FadeIn";

const ExamplePhotos = () => {
  const examples = [
    {
      id: 1,
      // src: "https://res.cloudinary.com/dxn6haxtz/video/upload/v1742943484/IG_reel_fitlikevinny_2024-10-17_or9brz.mp4",
      src: "https://res.cloudinary.com/dxn6haxtz/image/upload/v1743212252/ChatGPT_Image_Mar_28_2025_06_32_58_PM_ypo6hz.png",
      title: "Product in use",
      type: "image",
    },
    {
      id: 2,
      // src: "https://res.cloudinary.com/dxn6haxtz/image/upload/v1742943453/IMG_0465_2_wylevr.jpg",
      src: "https://res.cloudinary.com/dxn6haxtz/image/upload/v1743211988/ChatGPT_Image_Mar_28_2025_06_27_36_PM_zjjbnb.png",
      title: "Natural setting",
      type: "image",
    },
    {
      id: 3,
      // src: "https://res.cloudinary.com/dxn6haxtz/image/upload/v1742943819/3A37FC87-BB6F-4122-8FC5-35A3FB49270D_njc0bg.png",
      src: "https://res.cloudinary.com/dxn6haxtz/image/upload/v1743207987/ce1mul94ff2mnphykziv.png",
      title: "Lifestyle shot",
      type: "image",
    },
  ];

  return (
    <FadeIn>
      <div className="space-y-4">
        <div className="grid grid-cols-3 gap-3">
          {examples.map((example) => (
            <div key={example.id} className="relative aspect-[3/4] overflow-hidden rounded-lg border bg-muted">
              {example.type === "image" ? (
                <img
                  src={example.src}
                  alt={example.title}
                  className="h-full w-full object-cover object-top"
                />
              ) : (
                <video
                  autoPlay
                  muted
                  loop
                  src={example.src}
                  className="h-full w-full object-cover object-top"
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </FadeIn>
  );
};

export default ExamplePhotos;
